import { inject, observer } from "mobx-react";
import { Component } from "react";
import { withRouter, type WithRouterProps } from "~/nvent-web/utils/withRouter";
import { compose } from "nvent-web/utils/compose";

import ProjectForm from "nvent-web/components/ProjectForm";
import { ProjectsStore } from "nvent-web/stores/Projects";
import { type NewProjectFormValues } from "nvent-web/types/NewProjectFormValues";

interface NewProjectFormInnerProps extends WithRouterProps {
  projects: ProjectsStore;
}

const initialValues: NewProjectFormValues = {
  project: {
    name: "",
    addressAttributes: {
      streetAddress: "",
      postalCode: "",
      locality: "",
    },
    clientName: "",
    clientCompany: "",
    clientEmail: "",
    clientPhoneNumber: "",
  },
};

class NewProjectFormInner extends Component<NewProjectFormInnerProps> {
  render() {
    const { projects } = this.props;

    return (
      <ProjectForm
        initialValues={initialValues}
        onCancel={this.handleCancel}
        handleSubmit={projects.createProject}
        isSubmitting={projects.isProjectLoading}
      />
    );
  }

  private handleCancel = () => {
    this.props.navigate(-1);
  };
}

const NewProjectForm = compose<Record<string, unknown>>(
  inject("projects"),
  withRouter,
  observer
)(NewProjectFormInner);

export default NewProjectForm;
